import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageShell from '../ui/PageShell';
import Button from '../ui/Button';
import Footer from '../Footer';
import apiService from '../../services/ApiService';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  return (
    <PageShell>
      <div className="max-w-md mx-auto px-4 py-16">
        <h1 className="font-display text-3xl text-white font-semibold">Reset your password</h1>
        <p className="mt-2 text-sm text-gray-400">
          Enter your account email. If an account exists, we will send reset instructions.
        </p>
        <form
          className="mt-6 space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            setLoading(true);
            setMessage('');
            void apiService
              .forgotPassword(email.trim())
              .then((res: any) => setMessage(res.message || 'Check your email.'))
              .finally(() => setLoading(false));
          }}
        >
          <label className="block">
            <span className="input-label">Email</span>
            <input
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </label>
          <Button type="submit" variant="primary" loading={loading} className="w-full min-h-[44px]">
            Send reset link
          </Button>
        </form>
        {message ? (
          <p className="mt-4 text-sm text-emerald-300" role="status">
            {message}
          </p>
        ) : null}
        <p className="mt-6 text-sm text-gray-500">
          <Link to="/login" className="text-orange-300 hover:text-orange-200">
            Back to sign in
          </Link>
        </p>
      </div>
      <Footer />
    </PageShell>
  );
};

export default ForgotPasswordPage;
